// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"6af85beb","227":"5ecc3483","231":"86ca6cb3","453":"ecefb997","656":"7697312b","797":"419ac648","930":"9991e0d3"}[chunkId] + ".chunk.js";
};